module.exports = __webpack_public_path__ + "assets/images/premium-features/kiosk-0062ed.png";